module.exports = __webpack_public_path__ + "static/media/017-Fenster_schliessen_ID_1.f3eb5d30.mp3";